import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import {
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Schedule as ScheduleIcon,
} from '@mui/icons-material'
import { DashboardCard } from './DashboardCard'
import { DashboardStats } from '../../types/dashboard'

interface PersonalStatsProps {
  stats: DashboardStats
  onEnrollmentsClick?: () => void
}

export const PersonalStats: React.FC<PersonalStatsProps> = ({ stats, onEnrollmentsClick }) => {
  const { t } = useTranslation('dashboard')

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(4, 1fr)',
        },
        gap: { xs: 2, sm: 3 },
        mb: 4,
      }}
    >
      <DashboardCard
        title={t('personalStats.totalEnrollments')}
        value={stats.totalEnrollments}
        icon={<AssignmentIcon />}
        color="primary"
        onClick={onEnrollmentsClick}
      />
      <DashboardCard
        title={t('personalStats.completed')}
        value={stats.completedEnrollments}
        icon={<CheckCircleIcon />}
        color="primary"
      />
      <DashboardCard
        title={t('personalStats.incomplete')}
        value={stats.pendingEnrollments}
        icon={<ScheduleIcon />}
        color="secondary"
      />
      <DashboardCard
        title={t('personalStats.overdue')}
        value={stats.overdueEnrollments}
        icon={<WarningIcon />}
        color="secondary"
      />
    </Box>
  )
}
